export { MENU as DEFAULT_MENU } from "@/lib/menuData";

export const DEFAULT_IMAGES = {
  heroLogo: "/images/logo-sign.png",
  storyChapters: [
    "/images/refugio-aereo.png",
    "/images/pescador-ariane.png",
    "/images/guarda-sois-praia.png",
  ],
  menuFeatured: "/images/barca-do-rei.png",
  footerLogo: "/images/logo-180.png",
};

export const DEFAULT_CONTACT = {
  whatsapp: "5512997044344",
  instagramUrl: "https://instagram.com/rainhadomar7f",
  instagramHandle: "@rainhadomar7f",
};

export const DEFAULT_FEATURED = { title: "Barca do Rei", price: "R$ 318" };

// Corrige somente o preço legado incorreto, preservando edições futuras do proprietário.
export const normalizeFeatured = (featured) =>
  featured?.title === "Barca do Rei" && featured?.price === "R$ 375"
    ? { ...featured, price: "R$ 318" }
    : featured;
